import Navigator from "../../component/navigator";
import styles from "./index.module.scss";
import { useMemo, useState } from "react";
import classes from "classnames";
import useDocumentTitle from "../../hooks/use-document-title";

const AppDownload = () => {
  useDocumentTitle("APP下载");
  const [downloadClient, setDownloadClient] = useState<"ios" | "android">(
    "ios"
  );
  const downloadURL = useMemo(() => {
    if (downloadClient === "android") {
      return `https://python2fun.oss-cn-beijing.aliyuncs.com/qrcode/608e44152505ce5cba3a84c01.png`;
    }
    return `https://python2fun.oss-cn-beijing.aliyuncs.com/qrcode/608e44152505ce5cba3a84c00.png`;
  }, [downloadClient]);
  return (
    <div className={styles.appDownload}>
      <Navigator activeKey="app-download" />
      <div className={styles.container}>
        <div className={styles.cover} />
        <div className={styles.main}>
          <div className={styles.title}>哈希编程 - PythonTip学编程APP下载</div>
          <div className={styles.desc}>
            哈希编程APP是PythonTip推出的官方正版
            App，方便用户随时地在线学习和练习编程！
          </div>
          <div className={styles.downloadArea}>
            <img className={styles.qrcode} src={downloadURL} alt="" />
            <div className={styles.selection}>
              <button
                className={classes(downloadClient === "ios" && styles.active)}
                onClick={() => setDownloadClient("ios")}
              >
                IOS扫码下载
              </button>
              <button
                className={classes(
                  downloadClient === "android" && styles.active
                )}
                onClick={() => setDownloadClient("android")}
              >
                Android扫码下载
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDownload;
